import styled from 'styled-components';
import ReactEmptyState from '@jswork/react-empty-state';
import ImageIcon from 'common/components/ImageIcon';
import { Button, Icon } from 'antd';
import Srt from './srt';

const Container = styled.div`
  width: 100%;
  position: relative;
  height: 600px;
  .anticon {
    color: #fff;
  }
`;

export default props => {
  const { canEdit } = nx.$root.content;
  const suffixes = nx.get(props, 'data.config.suffixes');
  if (suffixes.includes('srt')) return <Srt />;

  return (
    <Container data-disabled={!canEdit}>
      <ReactEmptyState
        centered={true}
        className="w100"
        element={<ImageIcon value={'ic_word_grey@2x'} size={{ width: 102, height: 119 }} />}
        title={
          <View mt={27} mb={37} tc={true} f={14}>
            请将PPT课件文档文件拖拽到这里或者点击上传 <br />
            支持格式：PPTX
          </View>
        }>
        <Button type="primary">
          <Icon type="plus" />
          上传文档
        </Button>
      </ReactEmptyState>
    </Container>
  );
};
